import styled from "styled-components";

export const Message = styled.p`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  line-height: 21px;
  font-family: "Vy Sans", sans-serif;
  color: ${({ theme }) => theme.colorTextMain};
`;
